export default "__VITE_ASSET__Dr$GXSFD__"